<template>
  <PageTemplate :heading="heading">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </PageTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTemplate from '@/components/PageTemplate.vue';

export default {
  components: {
    PageTemplate,
  },

  computed: {
    ...mapGetters(['getLandlordId', 'getLandlordProfileMeta']),

    getLandlordProfile() {
      return this.getLandlordProfileMeta(this.getLandlordId);
    },

    heading() {
      if (!this.getLandlordProfile) {
        return '';
      }

      if (!this.$route.meta.name) {
        return this.getLandlordProfile.fullName;
      }
      return `${this.getLandlordProfile.fullName} - ${this.$route.meta.name}`;
    },
  },
};
</script>

<style scoped lang="scss">
.fade-enter-active {
  animation: bounceIn 0.8s;
}

@keyframes bounceIn {
  0% {
    transform: translate3d(0, 40px, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>
